import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import PerformancePlugin from './vue_performance_plugin';

export default function initPerformancePlugin(components) {
  Vue.use(PerformancePlugin, { components });
}
